<template>
  <div class="nav">
    <router-link
      :to="{ name: 'home', hash: '#hero', params: $route.params }"
      :class="{ hashActive: inViewSection === 'hero' }"
      class="menu-link"
      >Home</router-link
    >
    <router-link
      :to="{ name: 'home', hash: '#seatingExperiences', params: $route.params }"
      :class="{ hashActive: inViewSection === 'seatingExperiences' }"
      class="menu-link"
      >Seating Experiences</router-link
    >
    <!-- <router-link
      :to="{ name: 'home', hash: '#campusExperience', params: $route.params }"
      :class="{ hashActive: inViewSection === 'campusExperience' }"
      class="menu-link"
      >Campus Experience</router-link
    > -->
  </div>
</template>
<script>
export default {
  computed: {
    inViewSection() {
      return this.$store.getters["dom/getInViewSecion"];
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  z-index: 2;
  background-image: linear-gradient(0deg, #efefef 0%, #fdfdfd 100%);
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.33);
  border-radius: 0 0 20px 20px;
  padding: 1em;
  left: 50%;
  transform: translateX(-50%);
  a {
    font-family: Formula1-Display-Bold;
    font-size: 12px;
    color: #afafaf;
    text-align: center;
    line-height: 14px;
    font-weight: 500;
    text-decoration: none;
    margin: 0 1em;
    text-transform: uppercase;

    &.hashActive {
      color: #000000;
    }
  }
}
</style>